/**
 * Assertion on whether the object is a number or not
 * @param value Object to test
 * @returns `true` when the object is a number, `false` otherwise
 * @example
 * ```
 * isNumber(1) // returns true
 * ```
 */
export function isNumber(value: any): value is number {
  return typeof value === 'number';
}
